export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const toSelectItems = items =>
  items.map(item => ({
    value: item.code,
    label: item.name
  }))

export const toLeadOwner = (leadOwnerId, users) => {
  const owners = users.filter(user => user.value === leadOwnerId)
  if (owners.length === 1) {
    return owners[0]
  }
}
